// import { DatePicker } from "libraries/components/date-picker/date-picker";
// import convertToCurrency from "libraries/utils/convert-to-currency";
import { Line } from "react-chartjs-2";
import "./sale-statistics.scss";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  LineElement,
  Title,
  Tooltip,
  Legend,
  PointElement
);
const salesData = [
  { date: "2024-12-11", sales: 150 },
  { date: "2024-12-12", sales: 1800 },
  { date: "2024-12-13", sales: 1300 },
  { date: "2024-12-14", sales: 200 },
  { date: "2024-12-15", sales: 450 },
  { date: "2024-12-16", sales: 1350 },
  { date: "2024-12-17", sales: 500 },
];
export const SaleStatistic = () => {
  const labels = salesData.map((data) => data.date); // Trục X (ngày)
  const sales = salesData.map((data) => data.sales); // Trục Y (doanh số)

  const chartData = {
    labels, // Trục X: Ngày trong tuần
    datasets: [
      {
        label: "Daily Sales (USD)", // Nhãn biểu đồ
        data: sales, // Dữ liệu doanh số
        borderColor: "rgba(75, 192, 192, 1)", // Màu đường
        backgroundColor: "rgba(75, 192, 192, 0.2)", // Màu vùng dưới đường
        tension: 0, // Độ cong của đường
        pointBackgroundColor: "rgba(75, 192, 192, 1)", // Màu điểm
        pointBorderColor: "#fff", // Màu viền của điểm
        pointHoverRadius: 6, // Bán kính điểm khi hover
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true, // Hiển thị chú thích
        position: "top" as const,
      },
      title: {
        display: true,
        text: "Sales Data for the Week", // Tiêu đề biểu đồ
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Date",
        },
      },
      y: {
        title: {
          display: true,
          text: "Sales (USD)",
        },
        beginAtZero: true, // Bắt đầu từ 0
      },
    },
  };

  return (
    <div className="sale-statistic-container">
      <div className="sale-statistic-header">
        <div>
          <span className="title">{"Doanh thu"}</span>
        </div>
      </div>

      <div className="sale-statistic-body">
        <div className="chart-ctn">
          <div className="lineChart">
            <Line data={chartData} options={options} />
          </div>
        </div>
      </div>
    </div>
  );
};
